import { useQuery } from "@tanstack/react-query";
import Api from "../Api/Api.json";

const fetchData = async () => {
  const response = await fetch(Api.TELEDOC_PROVIDER_API, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      task: "getRPMPatientList",
    }),
  });
  console.log(response);
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  return response.json();
};

export const usePatients = () => {
  // Use React Query to fetch and cache data
  return useQuery({
    queryKey: ["RPMPatientList"], // Unique key for this query
    queryFn: fetchData, // Function to fetch data
    staleTime: 1000 * 60 * 5, // Data is considered fresh for 5 minutes
    cacheTime: 1000 * 60 * 10, // Cache data for 10 minutes
  });
};
